import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: row;
  gap: var(--space-200);
`

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--space-200);
`
